import { SharedBuergschaftsauftragService } from '@/shared/api/services/buergschaftsauftrag.ts';
import type { AblehungDTO } from '@/shared/Buergschaftsantraege/types/AblehungDTO.ts';
import type { BuergeDaten, Buergschaftsauftrag } from '@/types/Buergschaftsauftrag.ts';

export class BuergschaftsauftragService extends SharedBuergschaftsauftragService {
  async holeAblehnungsgrund(id: string | number): Promise<AblehungDTO> {
    return this.httpClient.get(`${this.baseUrl}/${id.toString()}/ablehnung`);
  }

  async lehneBuergschaftsauftragAb(
    id: number,
    buergenDaten: BuergeDaten,
  ): Promise<Buergschaftsauftrag> {
    return this.httpClient.post(`${this.baseUrl}/${id}/ablehnung`, { data: buergenDaten });
  }
}
